export default __webpack_public_path__ + "static/media/panda.5c991aae.png";